export default "__VITE_PUBLIC_ASSET__2f3e68c8__"